import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { IconButton, Stack, Tooltip } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'
import VolumeUpIcon from '@mui/icons-material/VolumeUp'
import VolumeOffIcon from '@mui/icons-material/VolumeOff'
import { useToggleSound } from '../model/useToggleSound'
import { NotificationSetup } from './NotificationSetup'
import { useRefresh } from '../model/useRefresh'
import { useStatusSwitch } from '../model/useStatusSwitch'
import { StatusSwitch } from './StatusSwitch'

export function SettingButtons({ waitingRoomId }: { waitingRoomId: string }) {
  useLingui()
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <RefreshButton waitingRoomId={waitingRoomId} />
      <SoundButton waitingRoomId={waitingRoomId} />
      <NotificationSetup waitingRoomId={waitingRoomId} />
      <StatusSwitchButton waitingRoomId={waitingRoomId} />
    </Stack>
  )
}

function RefreshButton({ waitingRoomId }: { waitingRoomId: string }) {
  const refresh = useRefresh(waitingRoomId)

  return (
    <Tooltip title={t`Refresh`}>
      <IconButton onClick={refresh} color="primary" size="small">
        <RefreshIcon />
      </IconButton>
    </Tooltip>
  )
}

function SoundButton({ waitingRoomId }: { waitingRoomId: string }) {
  const { isMuted, toggleMute } = useToggleSound(waitingRoomId)
  return (
    <Tooltip title={isMuted ? t`Unmute the sound` : t`Mute the sound`}>
      <IconButton onClick={toggleMute} color="primary" size="small">
        {isMuted ? <VolumeOffIcon /> : <VolumeUpIcon />}
      </IconButton>
    </Tooltip>
  )
}

function StatusSwitchButton({ waitingRoomId }: { waitingRoomId: string }) {
  const { checked, updateStatus } = useStatusSwitch(waitingRoomId)
  return <StatusSwitch checked={checked} onChange={updateStatus} />
}
